import {Color} from '@benchling/nucleus-ui';
import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ValidationIcon from 'samples/plate-maps/validation/ValidationIcon';
import {PlateMapErrorLevel} from 'samples/plate-maps/validation/ValidationTypes';

interface ValidationSymbolWellProps {
  /** The x-translation of the well relative to the plate map. */
  cx: number;
  /** The y-translation of the well relative to the plate map. */
  cy: number;
  /** The radius of the well. */
  radius: number;
  /** Error level to show. */
  errorLevel: PlateMapErrorLevel;
}

export default function ValidationSymbolWell({
  cx,
  cy,
  radius,
  errorLevel,
}: ValidationSymbolWellProps): JSX.Element {
  const size = radius * 2;
  return (
    <svg width={size} height={size} className={css(styles.svg)}>
      <circle cx={cx} cy={cy} r={radius} fill={Color.WHITE} />
      <foreignObject height={size} width={size} x={cx - radius} y={cy - radius}>
        <div className={css(styles.flexWrapper)}>
          <ValidationIcon level={errorLevel} size={12} />
        </div>
      </foreignObject>
    </svg>
  );
}

const styles = StyleSheet.create({
  svg: {overflow: 'visible'},
  flexWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
  },
});
